var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_789_36653",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1000,
    height: 1000
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 500,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_789_36653)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 500,
    cy: 500,
    r: 500,
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.543,
    cy: 303.093,
    r: 171.371,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 636.843,
    cy: 255.12,
    r: 92.0326,
    transform: "rotate(-26.4614 636.843 255.12)",
    fill: "#CECCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M710.17 310.765C721.739 284.961 721.585 252.852 707.109 223.77C687.356 184.084 647.028 162.278 609.022 167.377C604.561 168.798 600.152 170.577 595.831 172.728C550.328 195.377 531.8 250.625 554.449 296.128C577.098 341.631 632.346 360.158 677.849 337.51C690.984 330.972 701.872 321.717 710.17 310.765Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.593,
    cy: 654.646,
    r: 102.026,
    transform: "rotate(-49.5713 254.593 654.646)",
    fill: "#CECCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.574 679.478C354.142 648.133 340.014 615.462 312.601 592.107C275.191 560.237 224.583 555.55 188.051 577.287C184.121 580.676 180.399 584.409 176.929 588.483C140.387 631.375 145.536 695.769 188.428 732.31C231.321 768.851 295.714 763.703 332.256 720.811C342.804 708.429 349.878 694.256 353.574 679.478Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 591.615,
    cy: 873.357,
    r: 49.147,
    transform: "rotate(-49.5713 591.615 873.357)",
    fill: "#CECCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.295 885.319C639.569 870.22 632.763 854.481 619.558 843.231C601.538 827.879 577.159 825.621 559.561 836.092C557.668 837.725 555.875 839.523 554.203 841.485C536.601 862.147 539.081 893.166 559.743 910.769C580.405 928.371 611.424 925.891 629.026 905.229C634.107 899.265 637.515 892.437 639.295 885.319Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 516.501,
    cy: 922.361,
    r: 24.1581,
    transform: "rotate(-49.5713 516.501 922.361)",
    fill: "#B7B7B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M539.937 928.24C540.072 920.818 536.726 913.082 530.235 907.552C521.377 900.006 509.394 898.896 500.744 904.043C499.813 904.845 498.932 905.729 498.11 906.694C489.458 916.85 490.677 932.097 500.833 940.75C510.99 949.402 526.237 948.183 534.889 938.027C537.387 935.095 539.062 931.739 539.937 928.24Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 558.788,
    cy: 153.826,
    r: 24.7483,
    transform: "rotate(-24.0965 558.788 153.826)",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 666.582,
    cy: 618.731,
    r: 51.8968,
    transform: "rotate(-24.0965 666.582 618.731)",
    fill: "#DBDBDB"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 926.247,
    cy: 518.64,
    r: 116.742,
    transform: "rotate(-26.4614 926.247 518.64)",
    fill: "#CECCCC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1019.26 589.225C1033.94 556.492 1033.74 515.763 1015.38 478.873C990.325 428.532 939.169 400.871 890.96 407.34C885.301 409.141 879.708 411.399 874.226 414.127C816.506 442.857 793.005 512.938 821.735 570.658C850.464 628.378 920.545 651.879 978.265 623.149C994.927 614.856 1008.74 603.117 1019.26 589.225Z",
    fill: "#D9D9D9"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.023b982c06b641a2cdaac4388213e98e.svg";
export { ForwardRef as ReactComponent };